import { initAutocompleteWidget } from "./searchsync-autocomplete-component.js";
import { initClearRefinementsWidget} from "./searchsync-clear-refinements-component.js";
import { initCurrentRefinementsWidget } from "./searchsync-current-refinements-component.js";
import { initCourseStatusesRefinementList } from "./searchsync-course-statuses-rl-component";
import { initEnrollmentStatusRefinementList } from "./searchsync-enrollment-status-rl-component";
import { initFavoritesFilterWidget } from "./searchsync-favorites-filter-component";
import { initHitsPerPageWidget } from "./searchsync-hits-per-page-component";
import { initHitsWidget } from "./searchsync-hits-component";
import { initInfiniteHitsWidget } from "./searchsync-infinite-hits-component";
import { initMenuWidget } from "./searchsync-menu-component.js";
import { initMenuSelectWidget } from "./searchsync-menu-select-component";
import { initPaginationWidget } from "./searchsync-pagination-component";
import { initPoweredByWidget } from "./searchsync-powered-by-component";
import { initRefinementListWidget } from "./searchsync-refinement-list-component";
import { initSearchBoxWidget } from "./searchsync-search-box-component";
import { initSortByWidget } from "./searchsync-sortby-component";
import { initStatsWidget } from "./searchsync-stats-component";
import { initToggleRefinementWidget } from "./searchsync-toggle-refinement-component.js";

function setAccordionPanelOpen(panel, open) {
  panel.classList.toggle('is-open', open);
  const btn = panel.querySelector('.tgbl-filter-accordion__button');
  if (btn) btn.setAttribute('aria-expanded', String(open));
}

function initFilterAccordions() {
  // Grouped Filter Display containers (rendered by FilterHandler::render_grouped) honor the view's
  // grouped_filter_display settings, exposed as data-attrs on the wrapper:
  //   data-accordion      "true"|"false"  -- whether panels collapse at all
  //   data-open-multiple  "true"|"false"  -- allow more than one panel open at once
  //   data-default-open   "none"|"first"|"all" -- initial open state
  // Track the panels handled here so the standalone pass below skips them.
  const groupedPanels = new WeakSet();

  document.querySelectorAll('.tgbl-grouped-filters').forEach(group => {
    const panels = Array.from(group.querySelectorAll('.tgbl-filter-accordion'));
    panels.forEach(p => groupedPanels.add(p));

    // `load_accordion` off (and note data-accordion="false" is the DEFAULT for a view whose Grouped
    // Filter Display settings were never touched): every panel starts open and toggles
    // INDEPENDENTLY.
    //
    // This used to return early without attaching any handler, so the chevron that every filter
    // template renders was completely inert — clicking a grouped filter's header did nothing, which
    // is what made Menu and Menu Select look broken while standalone refinement lists worked fine.
    // `load_accordion` gates the *coordinated* accordion behaviour below (single-open via
    // data-open-multiple, initial state via data-default-open); it was never meant to decide whether
    // a section can collapse at all. Sections are collapsible either way now, so the rendered
    // affordance always matches what clicking does.
    if (group.getAttribute('data-accordion') !== 'true') {
      panels.forEach(panel => {
        setAccordionPanelOpen(panel, true);
        const btn = panel.querySelector('.tgbl-filter-accordion__button');
        if (!btn) return;
        btn.addEventListener('click', () => {
          setAccordionPanelOpen(panel, !panel.classList.contains('is-open'));
        });
      });
      return;
    }

    const openMultiple = group.getAttribute('data-open-multiple') === 'true';
    const defaultOpen = group.getAttribute('data-default-open') || 'none';

    panels.forEach((panel, i) => {
      const open = defaultOpen === 'all' || (defaultOpen === 'first' && i === 0);
      setAccordionPanelOpen(panel, open);

      const btn = panel.querySelector('.tgbl-filter-accordion__button');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const willOpen = !panel.classList.contains('is-open');
        // Single-open mode: close the other panels in this group before opening.
        if (willOpen && !openMultiple) {
          panels.forEach(p => { if (p !== panel) setAccordionPanelOpen(p, false); });
        }
        setAccordionPanelOpen(panel, willOpen);
      });
    });
  });

  // Standalone accordions (individual filter shortcodes, not inside a grouped container) keep the
  // original independent toggle and their server-rendered initial open state.
  document.querySelectorAll('.tgbl-filter-accordion__button').forEach(btn => {
    const accordion = btn.closest('.tgbl-filter-accordion');
    if (!accordion || groupedPanels.has(accordion)) return;
    btn.addEventListener('click', () => {
      const isOpen = accordion.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  });
}

document.addEventListener("DOMContentLoaded", function() {
  // TODO: get all searchsync-widget class elements
  //       loop through and check their types
  //       load based on found types
  initFilterAccordions();
  initAutocompleteWidget();
  initClearRefinementsWidget();
  initCurrentRefinementsWidget();
  initCourseStatusesRefinementList();
  initEnrollmentStatusRefinementList();
  initFavoritesFilterWidget();
  initHitsPerPageWidget();
  initHitsWidget();
  initInfiniteHitsWidget();
  initMenuWidget();
  initMenuSelectWidget();
  initPaginationWidget();
  initPoweredByWidget();
  initRefinementListWidget();
  initSearchBoxWidget();
  initSortByWidget();
  initStatsWidget();
  initToggleRefinementWidget();
})
